module.exports = __webpack_public_path__ + "static/media/Wasmachine.91ed5dea.mp3";